export const sinMP = {
  margin: "0px",
  padding: "0px",
};
